import { render, staticRenderFns } from "./VerifySuccess.vue?vue&type=template&id=20d651bb&scoped=true"
import script from "./VerifySuccess.vue?vue&type=script&lang=js"
export * from "./VerifySuccess.vue?vue&type=script&lang=js"
import style0 from "./VerifySuccess.vue?vue&type=style&index=0&id=20d651bb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d651bb",
  null
  
)

export default component.exports